import React from 'react';
import { CheckIcon, XIcon, ClockIcon, ArrowRightIcon } from 'lucide-react';
const rows = [{
  before: 'Notti intere a risolvere esercizi e creare slide da zero.',
  after: 'Lezioni, esercizi e soluzionari pronti sul tuo tablet in 2 clic.'
}, {
  before: 'Stress prima di spiegare concetti astratti a classi distratte.',
  after: "Sicurezza totale con slide visuali che semplificano l'astrazione."
}, {
  before: 'Spiegazioni teoriche che gli adolescenti trovano "impossibili".',
  after: 'Supporti visivi moderni (60% grafici e schemi / 40% testo).'
}, {
  before: 'Frustrazione per la burocrazia e il controllo del programma.',
  after: 'Checklist MIUR e griglie di valutazione già integrate.'
}, {
  before: 'Weekend sacrificati a correggere compiti e preparare verifiche.',
  after: 'Verifiche pronte con soluzionario: correggi in metà del tempo.'
}, {
  before: 'Difficoltà a coinvolgere studenti DSA e BES con lo stesso materiale.',
  after: 'Schede differenziate Base / Intermedio / Avanzato già pronte.'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-116">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(239,68,68,0.06) 0%, transparent 70%)'
    }} data-id="element-117"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-118">
        <div className="text-center mb-8 sm:mb-12" data-id="element-119">
          <span className="inline-block text-xs sm:text-sm font-bold text-badge-red uppercase tracking-[0.2em] mb-3 sm:mb-4" data-id="element-120">
            Il vero costo della preparazione manuale
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight leading-tight" data-id="element-121">
            Quanto tempo stai perdendo,
            <br className="hidden sm:block" data-id="element-122" />
            <span className="text-badge-red" data-id="element-123"> davvero</span>?
          </h2>
        </div>

        <div className="bg-gradient-to-br from-badge-red/10 to-badge-red/5 border border-badge-red/30 rounded-2xl sm:rounded-3xl p-6 sm:p-10 mb-10 sm:mb-14 relative overflow-hidden" data-id="element-124">
          <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-badge-red/10 blur-3xl pointer-events-none" data-id="element-125"></div>
          <div className="flex flex-col sm:flex-row items-center gap-5 sm:gap-8 relative z-10" data-id="element-126">
            <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-badge-red/20 border border-badge-red/40 flex items-center justify-center" data-id="element-127">
              <ClockIcon className="w-8 h-8 sm:w-10 sm:h-10 text-badge-red" strokeWidth={2.5} data-id="element-128" />
            </div>
            <div className="flex-1 text-center sm:text-left" data-id="element-129">
              <p className="text-text-main text-base sm:text-xl font-bold leading-relaxed" data-id="element-130">
                Progettare manualmente ogni lezione ti toglie in media da{' '}
                <span className="text-badge-red font-black whitespace-nowrap" data-id="element-131">
                  4 a 6 ore a settimana
                </span>
                .
              </p>
              <p className="text-badge-red font-black text-xl sm:text-3xl mt-2 leading-tight" data-id="element-132">
                Più di 200 ore all'anno. Per sempre.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-bg-alt rounded-2xl sm:rounded-3xl shadow-2xl border border-border-light overflow-hidden relative" data-id="element-133">
          <div className="grid grid-cols-2 border-b border-border-light bg-white/5 relative" data-id="element-134">
            <div className="px-4 sm:px-8 py-4 sm:py-6 font-black text-red-400 text-center md:text-left border-r border-border-light tracking-wider text-[10px] sm:text-sm uppercase flex items-center gap-2 sm:gap-3 justify-center md:justify-start" data-id="element-135">
              <span className="hidden sm:inline-flex w-7 h-7 rounded-full bg-badge-red/20 border border-badge-red/40 items-center justify-center flex-shrink-0" data-id="element-136">
                <XIcon className="w-4 h-4 text-badge-red" strokeWidth={3} data-id="element-137" />
              </span>
              <span data-id="element-138">
                <span className="hidden sm:inline" data-id="element-139">SENZA</span>
                <span className="sm:hidden" data-id="element-140">PRIMA</span>
                <span className="hidden sm:inline" data-id="element-141"> Matematica Pronta</span>
              </span>
            </div>
            <div className="px-4 sm:px-8 py-4 sm:py-6 font-black text-check-green text-center md:text-left tracking-wider text-[10px] sm:text-sm uppercase flex items-center gap-2 sm:gap-3 justify-center md:justify-start" data-id="element-142">
              <span className="hidden sm:inline-flex w-7 h-7 rounded-full bg-check-green/20 border border-check-green/40 items-center justify-center flex-shrink-0" data-id="element-143">
                <CheckIcon className="w-4 h-4 text-check-green" strokeWidth={3} data-id="element-144" />
              </span>
              <span data-id="element-145">
                <span className="hidden sm:inline" data-id="element-146">CON</span>
                <span className="sm:hidden" data-id="element-147">DOPO</span>
                <span className="hidden sm:inline" data-id="element-148"> Matematica Pronta</span>
              </span>
            </div>

            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 hidden md:flex w-10 h-10 rounded-full bg-bg-alt border border-border-light items-center justify-center shadow-lg z-10" data-id="element-149">
              <ArrowRightIcon className="w-5 h-5 text-primary" strokeWidth={2.5} data-id="element-150" />
            </div>
          </div>

          <div className="divide-y divide-border-light" data-id="element-151">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-2 group hover:bg-white/[0.02] transition-colors relative" data-id="element-152">
                <div className="px-4 sm:px-8 py-5 sm:py-7 flex items-start gap-3 sm:gap-4 border-r border-border-light bg-black/20" data-id="element-153">
                  <div className="w-5 h-5 sm:w-7 sm:h-7 rounded-full bg-badge-red/15 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/30" data-id="element-154">
                    <XIcon className="w-3 h-3 sm:w-4 sm:h-4 text-badge-red" strokeWidth={3} data-id="element-155" />
                  </div>
                  <p className="text-text-sec font-medium text-sm sm:text-base leading-relaxed" data-id="element-156">
                    {row.before}
                  </p>
                </div>
                <div className="px-4 sm:px-8 py-5 sm:py-7 flex items-start gap-3 sm:gap-4 bg-primary/5 relative overflow-hidden" data-id="element-157">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-158"></div>
                  <div className="w-5 h-5 sm:w-7 sm:h-7 rounded-full bg-check-green/15 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 relative z-10" data-id="element-159">
                    <CheckIcon className="w-3 h-3 sm:w-4 sm:h-4 text-check-green" strokeWidth={3} data-id="element-160" />
                  </div>
                  <p className="text-text-main font-bold text-sm sm:text-base leading-relaxed relative z-10" data-id="element-161">
                    {row.after}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <p className="text-center text-text-sec text-sm sm:text-base mt-8 sm:mt-10 max-w-2xl mx-auto leading-relaxed" data-id="element-162">
          Smetti di reinventare la ruota ogni settimana.{' '}
          <span className="text-text-main font-bold" data-id="element-163">
            Riprenditi il tuo tempo.
          </span>
        </p>
      </div>
    </section>;
}